document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.cart-rec-add');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const variantId = btn.getAttribute('data-variant-id');
  if (!variantId) return;

  btn.disabled = true;

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });

    document.dispatchEvent(new CustomEvent('cart:refresh'));
  } catch (err) {
    console.error(err);
    alert('No se pudo agregar al carrito. Intenta de nuevo.');
  } finally {
    btn.disabled = false;
  }
});
